// After a deploy, a tab that loaded the old version asks for code files
// (chunks) the new deploy no longer has, and the page lands on "Something
// went wrong". A full reload fetches the new version and fixes it, which is
// what Eduardo had to do by hand with a hard refresh. The error screens call
// this so the reload happens on its own, at most once a minute so a real
// error can never loop.

const STALE_PATTERNS = [
  /ChunkLoadError/i,
  /Loading (CSS )?chunk [\w-]+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
]

export function isStaleDeployError(error: { name?: string; message?: string } | null | undefined): boolean {
  if (!error) return false
  const text = `${error.name ?? ""} ${error.message ?? ""}`
  return STALE_PATTERNS.some((p) => p.test(text))
}

const KEY = "booth_stale_reload_at"
const WINDOW_MS = 60_000

/** Reloads once for a stale-deploy error. Returns true if it reloaded. */
export function reloadIfStaleDeploy(
  error: { name?: string; message?: string } | null | undefined,
  now: number = Date.now(),
  win: Pick<Window, "location" | "sessionStorage"> | undefined = typeof window === "undefined" ? undefined : window,
): boolean {
  if (!win || !isStaleDeployError(error)) return false
  try {
    const last = Number(win.sessionStorage.getItem(KEY) ?? 0)
    if (now - last < WINDOW_MS) return false
    win.sessionStorage.setItem(KEY, String(now))
  } catch {
    // No storage (private mode): still reload, the browser's own cache of
    // this page is gone after one reload anyway.
  }
  win.location.reload()
  return true
}
